// extracted by mini-css-extract-plugin
export var closeButton = "_66-0";